import { useLocation, useRouter } from '@tanstack/react-router'
import { type ReactNode, useEffect } from 'react'
import { profileRedirect } from '~/entities/profile/lib/profile-scope'
import { useProfileScope, useProfileSetupState } from '~/entities/profile/model/use-profiles'
import { Skeleton } from '~/shared/ui/skeleton'

/**
 * Shows a dashboard page only when it belongs to the active profile, else opens the one that does.
 * A business without any profile goes to the setup first.
 */
export function ProfileRouteGuard({ children }: { children: ReactNode }) {
  const router = useRouter()
  const location = useLocation()
  const { scope, isLoading: scopeLoading } = useProfileScope()
  const setup = useProfileSetupState()
  const isLoading = scopeLoading || setup.isLoading
  const href = isLoading
    ? null
    : setup.needsSetup
      ? '/setup/profile'
      : profileRedirect(location.pathname, location.search as Record<string, unknown>, scope)

  useEffect(() => {
    if (href) router.history.replace(href)
  }, [href, router])

  if (isLoading || href) return <Skeleton className="h-96 w-full rounded-xl" />
  return <>{children}</>
}
